module.exports = __webpack_public_path__ + "static/media/robert-jan.ef331418.png";